export const PPA_CLUB_ID = '80F17003-CD92-4FC4-84E4-06D38E096042';
